import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSettings = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -0.5 21 21",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M21 17.175 18.033 20l-8.901-8.475-2.967 2.825L0 8.48l2.967-2.826L6.165 8.7l2.967-2.826-3.203-3.049L8.896 0l6.17 5.874L12.099 8.7z"
	})
});
export default SvgSettings;
